import React from 'react';
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import Footer from '../../components/footer/Footer';
import backgroundimg  from '../../assets/images/cgwa-1.jpg';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_cgwa_banner from '../../assets/images/img_peso1_banner.png'; // Replace with an appropriate image path
import { FaWater, FaRegFileAlt, FaHandsHelping, FaCheckCircle, FaFileSignature, FaSearchLocation, FaComments, FaPaperPlane } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function CgwaCompliance() {
  const benefits = [
    {
      icon: <FaWater />,
      title: 'Sustainable Water Use',
      text: 'Ensure sustainable use of groundwater resources through compliance with CGWA norms.',
    },
    {
      icon: <FaRegFileAlt />,
      title: 'Legal Approval',
      text: 'Obtain mandatory permissions for groundwater extraction and avoid penalties.',
    },
    {
      icon: <FaHandsHelping />,
      title: 'Environmental Responsibility',
      text: 'Contribute to water conservation and environmental sustainability.',
    },
    {
      icon: <FaCheckCircle />,
      title: 'Operational Continuity',
      text: 'Avoid disruptions in operations due to regulatory non-compliance.',
    },
  ];

  const steps = [
    {
      icon: <FaComments />,
      title: 'Initial Consultation',
      description: 'Understand the specific requirements of your groundwater usage and compliance needs.',
    },
    {
      icon: <FaFileSignature />,
      title: 'Documentation Support',
      description: 'Assist in preparing and gathering all necessary documents as per CGWA guidelines.',
    },
    {
      icon: <FaSearchLocation />,
      title: 'Site Assessment',
      description: 'Conduct on-site evaluations and prepare hydro-geological reports if required.',
    },
    {
      icon: <FaPaperPlane />,
      title: 'Application Filing',
      description: 'Submit the application for groundwater extraction permissions to the CGWA.',
    },
    {
      icon: <FaCheckCircle />,
      title: 'Approval and Monitoring',
      description: 'Obtain the NOC and guide you in periodic compliance and monitoring as required.',
    },
  ];

  const acts = [
    'Environment Protection Act, 1986',
    'Water (Prevention and Control of Pollution) Act, 1974',
    'CGWA Guidelines for Groundwater Regulation, 2020',
  ];

  const explanation =
    'Central Ground Water Authority (CGWA) Compliance ensures the sustainable use of groundwater resources while adhering to regulatory norms. It involves obtaining NOCs for groundwater extraction, monitoring usage, and maintaining compliance with water conservation laws.';

  const checklistItems = [
    { name: 'Hydro-geological Report', description: 'Detailed report prepared by certified experts.' },
    { name: 'Groundwater Extraction Data', description: 'Information on the quantity and purpose of groundwater usage.' },
    { name: 'Industry Details', description: 'Business activities and site location specifics.' },
    { name: 'Water Conservation Plan', description: 'Plans for recharge and water-saving measures.' },
    { name: 'Compliance Reports', description: 'Proof of adherence to prior CGWA conditions (if applicable).' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Central Ground Water Authority (CGWA) Compliance Services"
        subheading="Expert assistance in meeting all regulatory requirements for groundwater usage."
        ctaPrimary={{ text: 'Request Assistance', link: '/contact-us' }}
        ctaSecondary={{ text: 'Learn More', link: '/cgwa-compliance' }}
        backgroundImage={backgroundimg} // Pass the background image here
      />

      <ServicesOverviewSection
        title="What is CGWA Compliance?"
        description="CGWA Compliance involves obtaining permissions and adhering to guidelines for groundwater extraction and usage. We provide comprehensive support to ensure your operations meet the legal requirements."
        image={img_cgwa_banner} // Replace with a relevant image
        altText="CGWA Compliance"
      />

      <ServicesBenefitsSection
        title="Why CGWA Compliance Matters?"
        description="Discover the benefits of adhering to CGWA norms for sustainable and lawful groundwater usage."
        benefits={benefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Key Legal Frameworks for CGWA Compliance"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our CGWA Compliance Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="CGWA Compliance Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
